import React from 'react';

export default function ComparisonView({ resumeHighlights = [], jobRequirements = [] }) {
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
			<div className="border rounded-md p-3">
				<h3 className="font-semibold mb-2">Resume Highlights</h3>
				<ul className="space-y-1 text-sm">
					{(resumeHighlights || []).map((t, i) => (
						<li key={i} className="text-green-700">✔ {t}</li>
					))}
				</ul>
			</div>
			<div className="border rounded-md p-3">
				<h3 className="font-semibold mb-2">Job Requirements</h3>
				<ul className="space-y-1 text-sm">
					{(jobRequirements || []).map((t, i) => (
						<li key={i} className="text-gray-700">• {t}</li>
					))}
				</ul>
			</div>
		</div>
	);
}


